import { jsx as _jsx } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useDispatch } from 'react-redux';
import Small from 'UIComponents/elements/Small';
import { FlowManager } from '../flow-management/FlowManager';
import { setNextStep } from '../flow-management/setNextStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { StyledUILink } from '../views-components/TextInput.styles';
import { Step } from '../views/Step';

const ResendCodeFooter = ({
  className
}) => {
  const stepKey = Step.CodeVerification;
  const dispatch = useDispatch();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();

  const goToResendEmailStep = event => {
    event.preventDefault();
    return dispatch(setNextStep({
      rebuilder: FlowManager.pushNextSteps(Step.ResendEmail)
    }));
  };

  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: StyledUILink,
          strong: ({
            children
          }) => /*#__PURE__*/_jsx("span", {
            children: children
          }),
          br: () => {
            return !isFramedCentredStep && /*#__PURE__*/_jsx("br", {});
          }
        },
        message: `views.${stepKey}.cantSeeEmail_jsx`,
        options: {
          onClick: goToResendEmailStep,
          href: ''
        }
      })
    })
  });
};

export default ResendCodeFooter;